import { faker } from "@faker-js/faker";

import {
  fakeAccountStatus,
  fakePronouns,
  fakeProviderType,
} from "@/__mocks__/mockBaseTypes";
import { merge } from "@/__mocks__/mockHelpers";

const fakeCareTeamProvider = (
  overrides?: DeepPartial<CareTeamProvider>,
): CareTeamProvider => {
  const provider: CareTeamProvider = {
    accountStatus: fakeAccountStatus(),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    pronouns: fakePronouns({}),
    providerExternalId: faker.string.uuid(),
    providerTypeName: fakeProviderType(),
  };
  return merge(provider, overrides);
};

export { fakeCareTeamProvider };
